import classNames from 'classnames';
import { ReactNode } from 'react';
import { DynamicComponent } from 'yoso';
import styles from './StickyBottom.module.scss';

type Props = {
  className?: string;
  children?: ReactNode;
};

export type StickyBottomProps<T = JSX.IntrinsicElements['div']> = DynamicComponent<Props, T>;

export const StickyBottom = <T = JSX.IntrinsicElements['div'],>({
  className,
  children,
  as: As = 'div',
  ...props
}: StickyBottomProps<T>) => (
  <As className={classNames(styles.root, className)} {...props}>
    {children}
  </As>
);
